import { Link } from "react-router-dom";
import { Clock, Users, ArrowUpRight } from "lucide-react";

export function CourseCard({ course, index = 0 }) {
  return (
    <Link
      to={`/kurslar/${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className="rise group flex flex-col rounded-3xl bg-white border border-bej overflow-hidden shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-navy/10"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-bej-light">
        {course.image_url && (
          <img src={course.image_url} alt={course.name} loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        )}
        <span className="absolute left-4 top-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-bold text-navy">
          {course.category_name}
        </span>
        <span className="absolute right-4 bottom-4 grid place-items-center w-10 h-10 rounded-full bg-navy text-white opacity-0 translate-y-2 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-y-0">
          <ArrowUpRight className="w-5 h-5" />
        </span>
      </div>
      <div className="flex flex-col gap-3 p-6 flex-1">
        <h3 className="font-heading text-xl font-extrabold text-navy">{course.name}</h3>
        <p className="text-sm text-slate-600 line-clamp-2 leading-relaxed">{course.description}</p>
        <div className="mt-auto flex flex-wrap gap-2 pt-2 text-xs font-semibold text-navy/80">
          {course.age_group && <span className="inline-flex items-center gap-1 rounded-full bg-bej-light px-3 py-1"><Users className="w-3.5 h-3.5" />{course.age_group}</span>}
          {course.duration && <span className="inline-flex items-center gap-1 rounded-full bg-bej-light px-3 py-1"><Clock className="w-3.5 h-3.5" />{course.duration}</span>}
          {course.price != null && <span className="rounded-full bg-navy text-white px-3 py-1" data-testid="course-card-price">{course.price.toLocaleString("tr-TR")} ₺</span>}
        </div>
      </div>
    </Link>
  );
}
